module.exports = __webpack_public_path__ + "img/svg/faq-separator.5190807067a16d9ea906e08e1c38edb8.svg";